import { useState } from "react"
import "./ratingStars.css"

export function RatingStars({ rating }) {
    const [stars, setStars] = useState([])

    for (var x = 0; x < 5; x++) {
        if (x === 0 && stars.length > 0) {
            setStars([])
        }
        else {
            if (x === Math.floor(rating)) {
                let decimal = rating - Math.floor(rating)

                if (decimal < 0.25) {
                    stars.push("star")
                }
                else if (decimal > 0.75) {
                    stars.push("star-filled")
                }
                else {
                    stars.push("star-half-filled")
                }
            }
            else {
                if (x < rating) {
                    stars.push("star-filled")
                }
                else {
                    stars.push("star")
                }
            }
        }
    }

    return (
        <div className="d-flex stars-section me-2">
            {
                stars.map((e, i) => (
                    <div key={i} className={`rating-star ${e}`}></div>
                ))
            }
        </div>
    )
}